// vendor libraries:
import { createTheme } from '@mui/material/styles';

// our stuff:

const rvDarkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

const rvLightTheme = createTheme({
  palette: {
    primary: {
      main: "#004B8D",
    },
    secondary: {
      main: "#00AA7E",
      contrastText: "#ffffff",
    },
    error: {
      main: "#D31245",
    },
    warning: {
      main: "#F79428",
    },
    info: {
      main: "#00A4D2",
    },
    success: {
      main: "#62BB46",
    },
    text: {
      primary: "#3f4040",
      secondary: "#828585", // #959797 in guidelines, which was shown to has too low contrast to be legible
      disabled: "#959797",
      // hint: "#959797",
    },
    background: {
      paper: "#ffffff",
      default: "#ffffff",
    },
  },
  shape: {
    borderRadius: 0,
  },
  typography: {
    h1: {
      fontWeight: 400,
    },
    h2: {
      fontWeight: 400,
    },
  },
  zIndex: {
    modal: 999999,
    snackbar: 9999999,
    tooltip: 99999999,
  },
});

export { rvLightTheme, rvDarkTheme };